'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

async function asyncNoop() { }

exports.asyncNoop = asyncNoop;
